import _ from "lodash";
import {
  fetchChannels,
  listenChatRoom,
  fetchSubChannels,
  fetchRooms,
  fetchConversations,
  markAsRead,
  deleteRoom,
  leaveChatRoom,
  listenSubChannel,
  leaveSubChannel,
  renameRoom,
  completeCase
} from "../util/chat";
import {
  userCanCreateChatRoom,
  userCanDeleteChatRoom,
  userCanEditChatRoom
} from "../permissions";

export default {
  data() {
    return {
      channels: [],
      subChannels: [],
      rooms: [],
      conversations: [],
      conversationsLoading: false,
      markAsReadSaving: false,
      fileOpening: false,
      roomDeleting: false,
      roomRenaming: false,
      roomSaving: false,

      calendarsLoading: false,
      subChannelsLoading: false,
      roomsLoading: false
    };
  },
  computed: {
    showOverlay() {
      return (
        this.conversationsLoading ||
        this.markAsReadSaving ||
        this.fileOpening ||
        this.roomDeleting ||
        this.calendarsLoading ||
        this.subChannelsLoading ||
        this.roomsLoading ||
        this.roomRenaming ||
        this.roomSaving ||
        this.userIsFetching
      );
    },
    sortedConversations() {
      return _.orderBy(this.conversations, ["id"], ["asc"]);
    },
    activeRooms() {
      return _.orderBy(
        this.rooms.filter(room => !room.completed_at),
        ["id"],
        ["asc"]
      );
    },
    histories() {
      return _.orderBy(
        this.rooms.filter(room => !!room.completed_at),
        ["completed_at"],
        ["desc"]
      );
    },

    currentChannel() {
      return !this.currentChannelId
        ? null
        : this.channels[
            this.channels.findIndex(c => c.id === this.currentChannelId)
          ];
    },

    currentSubChannel() {
      return !this.currentSubChannelId
        ? null
        : this.subChannels[
            this.subChannels.findIndex(c => c.id === this.currentSubChannelId)
          ];
    },

    currentRoom() {
      return !this.currentRoomId
        ? null
        : this.rooms[this.rooms.findIndex(c => c.id === this.currentRoomId)];
    }
  },
  methods: {
    onNewMessage(data) {
      if (
        this.currentRoomId === data.roomId &&
        !this.conversations.some(message => message.id === data.message.id)
      ) {
        // TODO: Clear Mention Ids
        this.mentionUserIds = [];
        this.conversations.push(data.message);
      }
    },
    onShowImage({ images, index }) {
      this.$refs["refImageViewer"].show(images, index);
    },
    onDownloadImage({ images, index }) {
      window.open(images[index].url);
    },
    async onNewRoomSaved(room) {
      this.$toasted.success(this.$t("general.saved") + ` "${room.name}"`, {
        icon: "check"
      });
      await this.changeRoomId(room.id);
      await this.fetchAllChannels();
    },
    onFindChatRoom() {
      this.$refs["refChatRoomFinder"].show(this.currentSubChannelId);
    },
    async onDeleteRoom({ id: roomId, title }) {
      if (await userCanDeleteChatRoom()) {
        if (
          !(await this.$confirm(
            this.$t("general.chatRoomCaption") + ` : "${title}"`,
            { dialogType: "delete" }
          ))
        )
          return;
        this.roomDeleting = true;
        try {
          const room = await deleteRoom(roomId, this.socketId);
          this.removeRoom(room);
        } catch (e) {
          console.log("error on delete room: ", _.get(e, "response", e));
        } finally {
          this.roomDeleting = false;
        }
      } else {
        this.$toasted.error(
          this.$t("general.permissionFailed.deleteChatRoom"),
          {
            icon: "mood_bad",
            className: "error"
          }
        );
      }
    },
    async onEditRoom(room) {
      if (await userCanEditChatRoom()) {
        this.$refs["refEditDialog2"].show(room);
      } else {
        this.$toasted.error(this.$t("general.permissionFailed.editChatRoom"), {
          icon: "mood_bad",
          className: "error"
        });
      }
    },
    async onCompleteCase(room) {
      if (await this.$confirm(this.$t("pages.chat.confirmationCompleteCase"))) {
        this.roomSaving = true;
        try {
          await completeCase(room.id, this.socketId);
          await this.fetchAllChannels();
        } catch (e) {
          console.log("error on complete case room: ", _.get(e, "response", e));
        } finally {
          this.roomSaving = false;
        }
      }
    },
    async onSaveRename(data) {
      this.roomRenaming = true;
      try {
        await renameRoom(data.id, data.body, this.socketId);
        this.$toasted.success(this.$t("general.saved"), { icon: "check" });
        await this.fetchAllChannels();
      } catch (e) {
        console.log("error on rename room: ", _.get(e, "response", e));
      } finally {
        this.roomRenaming = false;
      }
    },
    onNewChatRoom(subChannel) {
      this.$refs["refEditDialog"].show("create", { ...subChannel });
    },
    async onSelectFromFinder(room) {
      if (this.rooms.findIndex(r => r.id === room.id) > -1) {
        this.onSelectRoom(room);
      } else {
        await this.changeRoomId(room.id);
        await this.fetchAllChannels();
      }
    },
    onSomethingWrong(error) {
      if ("message" in error) {
        this.$toasted.error(error.message, {
          icon: "mood_bad",
          className: "error"
        });
        return;
      }
      this.$toasted.error(this.$t("general.somethingWrong"), {
        icon: "mood_bad",
        className: "error"
      });
    },

    async clearAllChannels() {
      await this.setOnlineUsersIds([]);
      this.channels = [];
    },
    fillChannel(channel) {
      this.channels.push(channel);
    },
    clearAllSubChannels() {
      this.subChannels.forEach(c => leaveSubChannel(this.echo, c.id));
      this.subChannels = [];
    },
    onNewRoom(room) {
      const ids = _.get(room, "user_ids", []);
      if (
        room.sub_channel_id === this.currentSubChannelId &&
        this.rooms.findIndex(r => r.id === room.id) === -1 &&
        Array.isArray(ids) &&
        ids.includes(this.user.id)
      ) {
        this.fillRoom({ ...room });
      }
    },
    fillSubChannel(channel) {
      this.subChannels.push(channel);
      listenSubChannel(this.echo, channel.id, { onNewRoom: this.onNewRoom });
    },
    clearAllRooms() {
      this.rooms.forEach(room => this.unsubscribeRoom(room));
      this.rooms = [];
    },
    fillRoom(room) {
      this.rooms.push(room);
      this.subscribeRoom(room);
    },
    removeRoom(room) {
      const idx = this.rooms.findIndex(r => r.id === room.id);
      if (idx > -1) {
        this.unsubscribeRoom(room);
        this.rooms.splice(idx, 1);
      }
    },
    onReceivedMessageNotify(message, roomId) {
      const idx = this.rooms.findIndex(r => r.id === roomId);
      if (
        this.currentRoomId === roomId &&
        idx > -1 &&
        this.onCanFillConversation()
      ) {
        return this.fillConversation(message);
      }
      if (idx > -1) this.rooms[idx].unreadCount += 1;
    },
    onRoomDeletedNotify(room) {
      this.removeRoom(room);
    },
    onRoomRenamedNotify(room) {
      const idx = this.rooms.findIndex(r => r.id === room.id);
      if (idx > -1) {
        this.rooms[idx].title = room.title;
      }
    },
    onRoomCompleteCaseNotify(room) {
      const idx = this.rooms.findIndex(r => r.id === room.id);
      if (idx > -1) {
        this.rooms[idx].completed_at = room.completed_at;
      }
    },
    subscribeRoom(room) {
      if (this.echo && typeof this.echo.socketId === "function") {
        this.socketId = this.echo.socketId();
      }
      listenChatRoom(this.echo, room.id, {
        onMessageReceived: this.onReceivedMessageNotify,
        onRoomDeleted: this.onRoomDeletedNotify,
        onRoomRenamed: this.onRoomRenamedNotify,
        onRoomCompleteCase: this.onRoomCompleteCaseNotify
      });
    },
    unsubscribeRoom(room) {
      leaveChatRoom(this.echo, room.id);
    },
    clearConversations() {
      this.conversations = [];
    },
    fillConversation(message) {
      this.conversations.push(message);
    },
    async onSelectChannel(channel) {
      this.subChannelsLoading = true;
      try {
        const subChannels = await fetchSubChannels(channel.id);
        if (Array.isArray(subChannels)) {
          this.clearAllSubChannels();
          await this.changeChannelId(channel.id);
          await this.setOnlineUsersIds(channel.user_ids);
          subChannels.forEach(channel => this.fillSubChannel(channel));
          if (subChannels.length === 1) {
            this.onSelectSubChanel(this.subChannels[0]);
            return;
          }
          const idx = this.subChannels.findIndex(
            c => c.id === this.currentSubChannelId
          );
          if (idx > -1) {
            this.onSelectSubChanel(this.subChannels[idx]);
            return;
          }
          await this.changeSubChannelId(0);
          this.clearAllRooms();
        }
      } catch (e) {
        this.clearAllSubChannels();
        this.clearAllRooms();
        console.log(
          "error on fetching sub-channels: ",
          _.get(e, "response", e)
        );
      } finally {
        this.subChannelsLoading = false;
      }
    },
    async onSelectSubChanel(subChannel) {
      this.roomsLoading = true;
      try {
        const rooms = await fetchRooms(subChannel.channel_id, subChannel.id);
        if (Array.isArray(rooms)) {
          await this.changeSubChannelId(subChannel.id);
          this.clearAllRooms();
          rooms.forEach(room => this.fillRoom(room));
          if (rooms.length === 1) {
            this.onSelectRoom(this.rooms[0]);
            return;
          }
          const idx = this.rooms.findIndex(c => c.id === this.currentRoomId);
          if (idx > -1) {
            this.onSelectRoom(this.rooms[idx]);
            return;
          }
          await this.changeRoomId(0);
        }
      } catch (e) {
        this.clearAllRooms();
        console.log("error on fetching rooms: ", _.get(e, "response", e));
      } finally {
        this.roomsLoading = false;
      }
    },
    async onSelectRoom(room) {
      // TODO: clear message after select new room
      if (room && room.id !== this.currentRoomId) {
        this.message = "";
        this.mentionUserIds = [];
        this.mentionUserHtml = "";
      }
      this.conversationsLoading = true;
      try {
        const conversations = await fetchConversations(room.id);
        if (Array.isArray(conversations)) {
          await this.changeRoomId(room.id);
          this.clearConversations();
          conversations.forEach(message => this.fillConversation(message));
          if (room.unreadCount) {
            const unreadCount = room.unreadCount;
            this.markAsReadSaving = true;
            await markAsRead(room.id);
            await this.$store.dispatch("notification/markAsReadChat", room.id);
            room.unreadCount = 0;
            const subChannel = this.subChannels[
              this.subChannels.findIndex(c => c.id === room.sub_channel_id)
            ];
            if (subChannel) {
              subChannel.unreadCount -= unreadCount;
              subChannel.unreadCount =
                subChannel.unreadCount < 0 ? 0 : subChannel.unreadCount;
              const channel = this.channels[
                this.channels.findIndex(c => c.id === room.channel_id)
              ];
              if (channel) {
                channel.unreadCount -= unreadCount;
                channel.unreadCount =
                  channel.unreadCount < 0 ? 0 : channel.unreadCount;
              }
            }
          }
          if (typeof this.switchToChatTab === "function") {
            this.switchToChatTab();
          }
        }
      } catch (e) {
        this.clearConversations();
        console.log(
          "error on fetching conversations: ",
          _.get(e, "response", e)
        );
      } finally {
        this.conversationsLoading = false;
        this.markAsReadSaving = false;
      }
    },
    async fetchAllChannels() {
      this.socketId = this.echo.socketId();
      this.calendarsLoading = true;
      try {
        const calendars = await fetchChannels();
        if (Array.isArray(calendars)) {
          await this.clearAllChannels();
          calendars.forEach(calendar => this.fillChannel(calendar));
          if (calendars.length === 1) {
            this.onSelectChannel(this.channels[0]);
            return;
          }
          const idx = this.channels.findIndex(
            c => c.id === this.currentChannelId
          );
          if (idx > -1) {
            this.onSelectChannel(this.channels[idx]);
            return;
          }
          await this.changeChannelId(0);
          this.clearAllSubChannels();
          this.clearAllRooms();
        }
      } catch (e) {
        await this.clearAllChannels();
        this.clearAllSubChannels();
        this.clearAllRooms();
        console.log("error on fetching calendar: ", _.get(e, "response", e));
      } finally {
        this.calendarsLoading = false;
      }
    },
    onMention() {
      this.$refs["refMentionDialog"].show(
        {
          mentionUserIds: this.mentionUserIds,
          roomId: this.currentRoomId
        },
        (ids, users = []) => {
          this.mentionUserIds = Array.isArray(ids) ? [...ids] : [];
          this.mentionUserHtml = "";
          users.forEach(user => {
            if (this.mentionUserHtml !== "") this.mentionUserHtml += "</br>";
            this.mentionUserHtml += user.name;
          });
        }
      );
    }
  }
};
